'use client';

import { ArrowRightIcon } from 'tdesign-icons-react';
import Link from 'next/link';
import SSVLink from '../ssv-link';
import { PlayCircleIcon } from 'tdesign-icons-react';

interface ILinkButton {
  linkHref?: string;
  children: React.ReactNode;
  className?: string;
  color?: string;
  backgroundColor?: string;
  arrowIcon?: boolean;
  disableTarget?: boolean;
  linkClassName?: string;
  [key: string]: any;
}

interface ISmallButtonProps {
  type?: 'arrowRight' | 'video';
  children: React.ReactNode;
  className?: string;
  color?: string;
  onClick?: () => void;
}
export const ALink = (props: {
  link?: string;
  children: React.ReactNode;
  className?: string;
}) => {
  const { link, children, className } = props;
  return link ? (
    <a className={className} href={link} target="_blank">
      {children}
    </a>
  ) : (
    children
  );
};
interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  link?: string;
  showArrow?: boolean;
  arrowColor?: string;
}
export const BigButton = (props: IButton) => {
  const {
    children,
    className,
    link,
    showArrow = true,
    arrowColor,
    ...rest
  } = props;

  return (
    <ALink link={link}>
      <button
        className={`bg-big-btn text-nowrap rounded-md text-white text-base -leading-[1px] py-5 px-[30px] relative shadow-btn2 flex items-center mobile:text-sm mobile:py-4 mobile:px-[65px] ${
          className || ''
        }`}
        {...rest}
      >
        {children}
        {showArrow && (
          <ArrowRightIcon className="ml-2" size="large" color={arrowColor} />
        )}
      </button>
    </ALink>
  );
};

const iconTypes = {
  arrowRight: (color?: string) => (
    <ArrowRightIcon
      style={{ color }}
      className="ml-2 text-active h-[18px] w-[18px] mobile:w-[14px] mobile:h-[14px] flex-none"
      size="large"
    />
  ),
  video: (color?: string) => (
    <PlayCircleIcon
      style={{ color }}
      className="ml-2 text-active h-[18px] w-[18px] mobile:w-[14px] mobile:h-[14px] flex-none"
      size="large"
    />
  ),
};

export const SmallButton: React.FC<ISmallButtonProps> = ({
  children,
  type = 'arrowRight',
  color,
  ...props
}) => {
  return (
    <button
      {...props}
      className="bg-white rounded-md text-active text-sm leading-none py-[10px] px-5 shadow-btn3 flex items-center mobile:text-xs font-500"
      style={{
        color,
      }}
    >
      <span className="line-clamp-1 break-all max-w-40 mobile:max-w-full">
        {children}
      </span>
      {iconTypes[type](color)}
    </button>
  );
};

export const LinkButton: React.FC<ILinkButton> = ({
  children,
  linkHref,
  className,
  color,
  backgroundColor,
  arrowIcon = true,
  disableTarget,
  linkClassName = '',
  ...rest
}) => {
  const target = disableTarget ? {} : { target: '_blank' };
  const btn = (
    <button
      className={`py-[10px] ${
        color ? 'bg-white' : 'bg-btn'
      } text-active text-sm px-[30px] flex items-center rounded-md mt-5 hover:shadow-btn mobile:text-xs mobile:leading-[18px] mobile:px-6 ${className}`}
      style={{
        color,
        backgroundColor,
      }}
      {...rest}
    >
      <span className="line-clamp-1 break-all">{children}</span>
      {color ? arrowIcon && iconTypes['arrowRight'](color) : ''}
    </button>
  );
  const list = ['/cooperate#cooperationHelp'];

  if (linkHref) {
    return (
      <>
        {list.includes(linkHref) ? (
          <SSVLink url={linkHref} {...target} className={linkClassName}>
            {btn}
          </SSVLink>
        ) : (
          <Link href={linkHref} {...target} className={linkClassName}>
            {btn}
          </Link>
        )}
      </>
    );
  }
  return <a>{btn}</a>;
};
